import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { CloneTaxonomyPopupComponent, CloneTaxonomyData } from '../components/clone-taxonomy-popup/clone-taxonomy-popup.component';

@Injectable({
  providedIn: 'root',
})
export class ClonePopupService {
  constructor(private dialog: MatDialog) {}

  openCloneDialog(data: CloneTaxonomyData): Observable<any> {
    const dialogRef = this.dialog.open(CloneTaxonomyPopupComponent, {
      autoFocus: false,
      width: '480px',
      panelClass: 'dialog-panel',
      backdropClass: 'backdrop-background',
      disableClose: true,
      data,
    });

    return dialogRef.afterClosed();
  }
}
